<div class="row search-bar" style="justify-content: space-between">
  <div class="col-lg-4 col-md-5 col-sm-5">
    <div class="form-group has-feedback input-group">
      <input (keyup.enter)="search()" [(ngModel)]="searchText" type="text"
             class="form-control has-feedback has-clear" id="search"
             style="font-family: Helvetica, FontAwesome" placeholder="&#xf002; Search...">
      <i *ngIf="searchText && router.url.includes('/site/list')"
         (click)="clearTextSearch()"
         class="fa fa-times form-control-feedback"
         style="padding-top:10px; z-index:10; pointer-events: auto; cursor:pointer; position: absolute; right: 67px;"></i>
      <span class="input-group-btn">
            <button type="button" class="btn btn-primary" (click)="search()">
                <i class="fa fa-search"></i>
            </button>
            </span>
      <app-help-docs-links style="padding: 5px;" recordType="search" color="#000"></app-help-docs-links>
    </div>

  </div>
  <div *ngIf="showFilter" class="col-lg-6 col-md-4 col-sm-2 activeFilters">
    <ng-template ngFor let-activeFilter [ngForOf]="activeFilters">
          <span class="btn btn-default"
                style="padding:1px 5px; margin: 5px;" (click)="clearSelectedFilter(activeFilter)"
                title="Clear this filter">
            <i class="fa fa-times"></i> {{ activeFilter.display }}
        </span>
    </ng-template>
  </div>
  <div *ngIf="showFilter" class="col-lg-2 col-md-4 col-sm-5 pull-right search-filter" ngbDropdown
        placement="bottom-end" #filterMenu="ngbDropdown">
    <div class="dropdown" id="filterMenu">
      <div ngbDropdownToggle>
        <span><i class="fa fa-long-arrow-down"></i> Filter</span>
        <p style="color:#b8bcc0; white-space: nowrap;">Use filters to narrow your search</p>
      </div>
      <div ngbDropdownMenu>
        <ul id="filterMenuItems">
          <li>
            <app-help-docs-links recordType="filter" color="#000" class="pull-right"></app-help-docs-links>
          </li>
          <li *ngIf="currentDataset === 'onestop'">
            <div class="form-group" style="padding-right:10px">
              <label>Permit Type:</label>
              <select class="form-control" [(ngModel)]="filter.one_stop_permit_type">
                <ng-template ngFor let-choice [ngForOf]="one_stop_permit_types">
                  <option [value]="choice.value">{{ choice.display_name }}</option>
                </ng-template>
              </select>
            </div>
          </li>
          <li *ngIf="currentDataset === 'precerclis'">
            <div class="form-group" style="padding-right:10px">
              <label>Exposure Pathway:</label>
              <select class="form-control" [(ngModel)]="filter.precerclis_exposure">
                <ng-template ngFor let-choice [ngForOf]="precerclis_exposures">
                  <option [value]="choice.value">{{ choice.display_name }}</option>
                </ng-template>
              </select>
            </div>
          </li>
          <li *ngIf="currentDataset === 'precerclis'">
            <div class="form-group" style="padding-right:10px">
              <label>Circumstances:</label>
              <select class="form-control" [(ngModel)]="filter.precerclis_circumstance">
                <ng-template ngFor let-choice [ngForOf]="precerclis_circumstances">
                  <option [value]="choice.value">{{ choice.display_name }}</option>
                </ng-template>
              </select>

            </div>
          </li>
          <li *ngIf="currentDataset === 'solidwaste'">
            <div class="form-group" style="padding-right:10px">
              <label>Latest Permit Status:</label>
              <select class="form-control" [(ngModel)]="filter.solidwaste_status">
                <ng-template ngFor let-choice [ngForOf]="solidwaste_complaint_status">
                  <option [value]="choice.value">{{ choice.display_name }}</option>
                </ng-template>
              </select>
            </div>
          </li>
          <li *ngIf="currentDataset === 'beach'">
            <div class="form-group" style="padding-right:10px">
              <label>Currently Under Advisory:</label>
              <select class="form-control" [(ngModel)]="filter.beaches_under_advisory">
                <ng-template ngFor let-choice [ngForOf]="beaches_under_advisory_choices">
                  <option [value]="choice.value">{{ choice.display_name }}</option>
                </ng-template>
              </select>
            </div>
          </li>
          <li *ngIf="currentDataset === 'ust'">
            <div class="form-group" style="padding-right:10px">
              <label>Enforcement Action Past Due:</label>
              <input type="checkbox" [(ngModel)]="filter.ust_past_due_actions">
            </div>
          </li>
          <li>
            <div class="form-group" style="padding-right:10px">
              <label>Programs:</label>
              <select class="form-control" [(ngModel)]="filter.selectedInterests" multiple>
                <option *ngFor="let option of interestOptions" [value]="option.id">
                  {{ option.label }}
                </option>
              </select>
            </div>
          </li>
          <li>
            <div class="form-group" style="padding-right:10px">
              <label>Village:</label>
              <select class="form-control" [(ngModel)]="filter.village">
                <option *ngFor="let choice of villages" [value]="choice.value">
                  {{ choice.display_name }}
                </option>
              </select>
            </div>
          </li>
          <li>
            <div class="form-group" id="last_edited_after" style="padding-right:10px">
              <label>Last Edited After:</label>
              <div class="input-group">
                <input type="text" class="form-control" ngbDatepicker #d="ngbDatepicker"
                       [(ngModel)]="filter.edit_start" placeholder="YYYY-MM-DD"/>
                <span class="input-group-btn">
                <button type="button" class="btn btn-default" (click)="d.toggle()">
                  <i class="fa fa-calendar"></i>
                </button>
              </span>
              </div>
              <!--            <div class="input-group">-->

              <!--              <input type="text" class="form-control" uib-datepicker-popup="yyyy-MM-dd"-->
              <!--                     datepicker-options="dateOptions" [(ngModel)]="filter.edit_start"-->
              <!--                     is-open="open.edit_start"/>-->

              <!--              <span class="input-group-btn">-->
              <!--                                <button type="button" class="btn btn-default"-->
              <!--                                        (click)="openCalendar($event, 'edit_start')"-->
              <!--                                        style="height:34px;"><i class="fa fa-calendar"></i></button>-->
              <!--                            </span>-->
              <!--            </div>-->
            </div>

          </li>
          <li>

            <div class="form-group" id="last_edited_before" style="padding-right:10px">
              <label>Last Edited Before:</label>
              <div class="input-group">
                <input type="text" class="form-control" ngbDatepicker #endd="ngbDatepicker"
                       [(ngModel)]="filter.edit_end" placeholder="YYYY-MM-DD"/>
                <span class="input-group-btn">
                <button type="button" class="btn btn-default" (click)="endd.toggle()">
                  <i class="fa fa-calendar"></i>
                </button>
              </span>
              </div>
            </div>

          </li>
          <li>
            <div class="form-group" id="needs_review_flag" style="padding-right:10px;">

              <p class="input-group">
                <label><span style="padding-right:15px;">Needs Review</span></label>
                <input type="checkbox" [(ngModel)]="filter.needs_review"/>
              </p>
            </div>
          </li>
          <li style="display: flex; justify-content: space-between;">
            <button type="button" class="btn btn-primary" id="filterButton"
                    (click)="applyFilter()">Apply
            </button>
            <button type="button" class="btn btn-secondary" id="clearFilter2"
                    (click)="clearFilters()">Clear Filter
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
